import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/AppNotification`
export const GetList = `${apiUrl}`
export const Get = (id: number) => `${apiUrl}/${id}`
export const View = (id: number) => `${apiUrl}/view/${id}`
export const Post = `${apiUrl}`
export const Put = (id: number) => `${apiUrl}/${id}`
export const Delete = (id: number) => `${apiUrl}/${id}`
export const GetNewestId = `${apiUrl}/newest`

export interface NotificationData {
  Id: number
  Title: string
  Notification: string
  CreatedAt: string
  UserName: string
  UserId: number
  PublishUnit: string
}

export interface NotificationFormData {
  Title: string
  Notification: string
  PublishUnit: string
}

export interface NotificationFilter {
    Page: number,
    PageSize: number,
    SortBy: string,
    IsAsc: boolean,

    Keyword: string,
    StartDate: string,
    EndDate: string
}

export const getList = (params: NotificationFilter) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params
    })
}

export const getData = (id: number) => {
  return tryAxios({
      method: 'get',
      url: Get(id)
  })
}
export const viewData = (id: number) => {
  return tryAxios({
      method: 'get',
      url: View(id)
  })
}
/** 最新的公告id */
export const getNewestId = () => {
  return tryAxios({
      method: 'get',
      url: GetNewestId
  })
}

export const postData = (data: NotificationFormData) => {
  return tryAxios({
    method: 'post',
    url: Post,
    data
  })
}

export const putData = (id: number, data: NotificationFormData) => {
  return tryAxios({
    method: 'put',
    url: Put(id),
    data
  })
}

export const remove = (id: number) => {
  return tryAxios({
    method: 'delete',
    url: Delete(id)
  })
}